import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DetailRow {
  label: string;
  value?: string;
}

@Component({
  selector: 'app-case-detail-section',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (row of rows(); track row.label) {
      @if (row.value) {
        <div class="detail-row">
          <div class="detail-label">{{ row.label }}</div>
          <div class="detail-value">{{ row.value }}</div>
        </div>
      }
    }
  `,
  styles: [`
    .detail-row {
      margin-bottom: 0.75rem;
    }
    .detail-label {
      font-size: 0.7rem;
      font-weight: 500;
      color: #94a3b8;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      margin-bottom: 2px;
    }
    .detail-value {
      font-size: 0.8125rem;
      font-weight: 500;
      color: #1e293b;
      word-break: break-word;
    }
    :host:last-child .detail-row:last-child {
      margin-bottom: 0;
    }
  `],
})
export class CaseDetailSectionComponent {
  rows = input.required<DetailRow[]>();
}
